// Canonical copy for the inline-JSON example editor, shared by the Create Run
// ("Provide JSON") and Create Source (JSON type) forms so the two stay in sync.
// KANP-553: the forms had drifted (different label, helper-text spacing, and
// placeholder payload). This module is the single source of truth — render these
// constants instead of re-declaring the strings per form.

export const EXAMPLES_JSON_LABEL = 'Examples JSON Data';

export const EXAMPLES_JSON_HELP = 'Paste your examples as JSON. Format: {"examples":[...]}';

// Placeholder hint shown in the empty editor: one example with a trailing `...`
// to signal that the `examples` array can hold more. Kept to a single example so
// it fits the editor without clipping or forcing an oversized box (KANP-553).
// This is display-only hint text — never parsed — so the `...` is intentional and
// deliberately not valid JSON.
export const EXAMPLES_JSON_PLACEHOLDER = `{
  "examples": [
    {
      "type": "message",
      "data": [
        { "user": "user", "message": "What's your return policy?" },
        { "user": "assistant", "message": "We offer 30-day returns on all items." }
      ],
      "meta_data": { "context": "optional" }
    },
    ...
  ]
}`;
